import {
	ADMINGETFEEMASTERLIST_SUCCESS,
	ADMINGETFEEMASTERLIST_FAILED,
	RESET_ADMINGETFEEMASTERLIST,
	LOADING_ADMINGETFEEMASTERLIST,
	NETWORK_ERROR_ADMINGETFEEMASTERLIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetFeeMasterList = () => {
	return { type: RESET_ADMINGETFEEMASTERLIST };
};

const adminGetFeeMasterList = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINGETFEEMASTERLIST });
	await adminServices
		.post("getFeeMasterList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGetFeeMasterListsuccess(res.data));
					break;
				default:
					dispatch(adminGetFeeMasterListFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINGETFEEMASTERLIST,
				payload: err
			});
		});
};
function adminGetFeeMasterListsuccess(data) {
	return {
		type: ADMINGETFEEMASTERLIST_SUCCESS,
		payload: data
	};
}
function adminGetFeeMasterListFailed(data) {
	return {
		type: ADMINGETFEEMASTERLIST_FAILED,
		payload: data
	};
}

export { resetAdminGetFeeMasterList, adminGetFeeMasterList };
